'use strict';

// This component simply prints out the number of Mogo Members

// TODO: In the future it should be adjusted (and likely renamed) to be able to grab and print any key from Contentful. Step one was consolidating this code in a component, it was repeated in 6 page js files.

function SocialProofNumber() {
  this.id = null;
  this.node = null;

  this.el = {};

  this._classes = {
    mogoMemberCount: 'js--social-proof-mogo-member-count',
    teamMemberCount: 'js--social-proof-team-member-count',
    roundNumber: 'js--social-proof-round-number'
  };

  this.init = function () {};

  this.initAllReady = function () {
    this.el.$mogoMemberCount = $('.' + this._classes.mogoMemberCount);
    this.el.$teamMemberCount = $('.' + this._classes.teamMemberCount);
    this._mogoMembers();
    this._teamMembers();
  };

  // MKTG-375: read from local snapshots instead of Contentful entries.
  this._mogoMembers = function () {
    var _this = this;

    ContentSnapshots.load('entry-socialProof-mogoMembers').done(function (contentfulData) {
      _this.contentfulData = contentfulData.items[0].value;

      $(_this.node).find(_this.el.$mogoMemberCount).text(_this.contentfulData);
      if (_this.el.$mogoMemberCount.hasClass(_this._classes.roundNumber)) {
        var currentNum = parseInt(_this.contentfulData.split(',').join(''));
        var currentNumRound = currentNum / 1000000;
        _this.el.$mogoMemberCount.text(currentNumRound);
      } else {
        _this.el.$mogoMemberCount.text(_this.contentfulData);
      }
    });
  };

  this._teamMembers = function () {
    var _this2 = this;

    ContentSnapshots.load('entry-socialProof-teamMembers').done(function (contentfulData) {
      _this2.contentfulData = contentfulData.items[0].value;

      $(_this2.node).find(_this2.el.$teamMemberCount).text(_this2.contentfulData);
    });
  };
}